import { render, staticRenderFns } from "./accessInvite-send-dialog.vue?vue&type=template&id=31bf4522&scoped=true&"
import script from "./accessInvite-send-dialog.vue?vue&type=script&lang=js&"
export * from "./accessInvite-send-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf4522",
  null
  
)

export default component.exports